import React from "react";
import { useNavigate } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import SEO from "../../components/SEO/SEO";
import {
  Container,
  NotFoundCard,
  ErrorCode,
  Title,
  Message,
  HomeButton,
} from "./NotFoundPage.styles";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <SEO title="Stranica nije pronađena" noindex />

      <NotFoundCard>
        <ErrorCode>404</ErrorCode>
        <Title>Stranica nije pronađena</Title>
        <Message>
          Stranica koju tražite ne postoji ili je premeštena. Proverite adresu
          ili se vratite na početnu stranicu.
        </Message>
        <HomeButton onClick={() => navigate("/")}>
          <FaHome />
          Nazad na početnu
        </HomeButton>
      </NotFoundCard>
    </Container>
  );
};

export default NotFoundPage;
